// Turns the thumb's offset from the stick centre into steering and throttle, both in [-1, 1].
// Tuned for a thumb on a phone: a small dead zone, finer steering near the centre, and braking or reversing only on a
// deliberate pull (a thumb drifting down while accelerating must not slow the bike).
export const DEAD_ZONE = 0.12;
export const BRAKE_FROM = 0.4;
const STEER_CURVE = 1.35;

const clampUnit = (v) => Math.max(-1, Math.min(1, v));

// Removes the dead zone and stretches what is left back to the full range.
const rescale = (v) => Math.sign(v) * Math.max(0, (Math.abs(v) - DEAD_ZONE) / (1 - DEAD_ZONE));

// dx, dy: thumb offset in pixels, x to the right and y down; radius: offset that counts as full deflection.
export function stickAxes(dx, dy, radius) {
  let nx = dx / radius,
    ny = dy / radius;
  const len = Math.hypot(nx, ny);
  if (len > 1) {
    nx /= len;
    ny /= len;
  }
  const steer = rescale(-nx),
    up = -ny;
  return {
    // + 0 turns a negative zero into a plain zero
    st: clampUnit(Math.sign(steer) * Math.abs(steer) ** STEER_CURVE) + 0,
    thr: (up >= 0 ? rescale(up) : -Math.max(0, (-up - BRAKE_FROM) / (1 - BRAKE_FROM))) + 0,
  };
}
